import { cn } from 'cn';
import type { ReactElement, ReactNode } from 'react';
import Tooltip from '../../Tooltip/Tooltip';

interface InputLabelProps {
  inputId: string;
  label?: ReactNode;
  labelClassName?: string;
  labelDescription?: ReactNode;
  tooltip?: string;
}

export function InputLabel({
  inputId,
  label,
  labelClassName,
  labelDescription,
  tooltip,
}: InputLabelProps): ReactElement | null {
  if (!label) return null;

  return (
    <Tooltip tooltip={tooltip} enabled={!!tooltip}>
      <div>
        <label
          htmlFor={inputId}
          className={cn('laane:mb-1 block', labelClassName)}
        >
          {label}
        </label>
        {labelDescription ? (
          <div
            className={cn(
              'laane:contents kunde:text-neutral-100 kunde:text-2xs',
            )}
          >
            {labelDescription}
          </div>
        ) : null}
      </div>
    </Tooltip>
  );
}
